var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 0.499969L0.65625 1.74997M8.625 0.499969L10.3438 1.74997M1.125 6.12497C1.125 6.6995 1.23816 7.26841 1.45803 7.79921C1.67789 8.33001 2.00015 8.8123 2.40641 9.21856C2.81266 9.62482 3.29496 9.94708 3.82576 10.1669C4.35656 10.3868 4.92547 10.5 5.5 10.5C6.07453 10.5 6.64344 10.3868 7.17424 10.1669C7.70504 9.94708 8.18734 9.62482 8.59359 9.21856C8.99985 8.8123 9.32211 8.33001 9.54198 7.79921C9.76184 7.26841 9.875 6.6995 9.875 6.12497C9.875 4.96465 9.41407 3.85185 8.59359 3.03138C7.77312 2.21091 6.66032 1.74997 5.5 1.74997C4.33968 1.74997 3.22688 2.21091 2.40641 3.03138C1.58594 3.85185 1.125 4.96465 1.125 6.12497Z",
    stroke: "#4EC040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.12503H3.625L4.875 8.00003L6.125 4.25003L7.375 6.12503H8",
    stroke: "#4EC040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.37577793c84c4ebf548c8c09899d539e.svg";
export { ForwardRef as ReactComponent };